module.exports = __webpack_public_path__ + "img/reference-jugend-diskurs.4428a4c2.jpg";